<template>
  <div class="ver_whole">
    <div class="picture">
      <figure>
        <img class="icon" :src="form.appIconUrl" />
        <figcaption>
          <img src="@/assets/Android.png" />
          <span class="name">{{ form.appName }}</span>
          <p class="status">内测版</p>
        </figcaption>
        <figcaption>
          <p>版本：{{ form.appVersion }}</p>
          <p class="line"></p>
          <p>更新时间：{{ form.updateTime | formateTitle }}</p>
        </figcaption>
      </figure>
      <figure>
        <div class="ver_icon">
          <vue-qr
            :logoSrc="appIconUrls"
            :text="'http://192.168.0.65:8081/#/app_downLoad?id=' + form.id"
            :logoScale="60"
            :size="300"
          ></vue-qr>
          <!--:text="'pack_' + form.id"-->
          <!--:text="'http://192.168.0.65:8081/#/app_downLoad'"-->
          <!-- <qrcode-vue size="300" level="H" :value="form.apkUrl"> </qrcode-vue> -->
          <!-- <img :src="form.appIconUrl" /> -->
        </div>

        <figcaption>
          <a :href="form.apkUrl" download="文件下载">
            <el-button @click="download_fun(form.id)"
              >下载{{ form.apkSize }}</el-button
            >
          </a>
        </figcaption>
      </figure>
    </div>
    <div class="context">
      <p class="title">详情</p>
      <div class="app_pic">
        <img
          v-for="(item, index) in form.previewUrl"
          :src="item"
          :key="item + index"
        />
      </div>
      <p class="title">应用介绍</p>
      <div class="con_text pop">
        {{ form.applicationRecommend }}
      </div>
      <p class="title">版本说明</p>
      <div class="pop">{{ form.versionDesc }}</div>
      <p class="title">其他信息</p>
      <div class="pop">
        开发者：{{ form.appRelease }} 更新时间：{{
          form.updateTime | formateTitle
        }}
      </div>
      <div class="pop">版本：{{ form.appVersion }}</div>
    </div>
  </div>
</template>
<script>
import VueQr from "vue-qr";
import { countTimes } from "@/api/tool_app";
export default {
  components: {
    VueQr,
  },
  data() {
    return {
      appIconUrls: require("@/assets/logo.png"),
      size: "23.4Mb",
      developer: "王安石",
      form: {},
    };
  },
  mounted() {
    this.fun();
  },
  methods: {
    fun() {
      var str = [
        "a",
        "s",
        "d",
        "a",
        "s",
        "d",
        "f",
        "d",
        "g",
        "s",
        "d",
        "f",
        "s",
      ];
      var sets = Array.from(new Set(str));
      for (let i = 0; i < sets.length; i++) {
        var num = 0;
        for (let j = i + 1; j < str.length; j++) {
          if (sets[i] === str[j]) {
            num++;
          }
        }
        console.log(sets[i], num);
      }
    },
    download_fun(id) {
      console.log("122", id);
      let res = countTimes({
        id: id,
        type: 2,
      });
    },
  },
  created() {
    //判断对象是否不为空
    for (let i in this.$route.params) {
      return (this.form = this.$route.params);
    }
  },
};
</script>
<style lang="scss" scoped>
.ver_whole {
  flex: 1;
  overflow: auto;
  .picture {
    figure {
      text-align: center;

      & > figcaption:last-child {
        @include s-c-w(12, $text-other, 500);
      }
      figcaption {
        margin-top: 10px;
        align-items: center;
        display: flex;
        justify-content: center;
        .el-button {
          width: 251px;
          background-color: $tab;
          @include s-c-w(14, $menu-color, 500);
          border-radius: 8px;
        }
        .name {
          margin: 0px 10px 0px 10px;
          @include s-c-w(16, $detail_t, bold);
        }
        .status {
          width: 46px;
          height: 18px;
          border-radius: 4px;
          background-color: $status;
          @include s-c-w(12, $menu-color, 500);
        }
        .line {
          width: 1px;
          height: 14px;
          background-color: $border;
          margin: 0px 8px 0px 30px;
        }
        img {
          width: 28px;
          height: 16px;
        }
      }
      .icon {
        width: 106px;
        height: 106px;
      }
      .ver_icon {
        width: 116px;
        height: 116px;
        background-color: $menu-color;
        margin: 30px auto;
        img {
          width: 116px;
          height: 116px;
        }
      }
    }
  }
  .context {
    border-radius: 11px;
    margin: 30px 86px;
    padding: 0px 205px 30px 205px;
    text-align: center;
    background-color: $menu-color;
    .title {
      padding: 30px 0px;
      @include s-c-w(16, $detail_t, bold);
    }
    .pop {
      @include s-c-w(12, $text-one, 500);
    }
    .con_text {
      text-align: left;
    }
    .app_pic {
      display: flex;
      overflow-x: auto;
      img {
        margin-right: 10px;
        width: 152px !important;
        height: 270px;
      }
    }
  }
}
</style>